import type { PintxoAccessibilityTags, PintxoConfig } from './types'

export type { PintxoConfig, PintxoAccessibilityTags } from './types'

let pintxoConfig: PintxoConfig = {
  accesibilityTags: {
    close: 'Close',
    collapse: 'Collapse',
    expand: 'Expand',
    next: 'Next',
    previous: 'Previous',
    slides: 'Slides',
    getDotReference: (index: number) => `Slide ${index + 1}`,
    getSlideOfTotal: (index: number, pages: number) => `Slide ${index + 1} of ${pages + 1}`
  },
}

export const setPintxoConfig = (config: Partial<PintxoConfig>) => {
  pintxoConfig = { ...pintxoConfig, ...config }
}

export const getPintxoConfig = (): PintxoConfig => pintxoConfig
export const getAccessibilityTags = (): PintxoAccessibilityTags => pintxoConfig.accesibilityTags
